import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/ui/PageHeader";
import CustomInput from "../../components/ui/CustomInput";
import axios from "../../api/axiosClient";
import { useLoading } from "../../components/LoadingContext";
import { errorToast, handleError } from "../../services/serviceBase";
import { Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, Radio, RadioGroup, Typography } from "@mui/material";
import UploadExcelModal from "../../components/Modals/UploadExcelModal";

const ManualRTV = () => {
    const intl = useIntl();

    const [types, setTypes] = useState([{text: "Retail", value: "R"}, {text: "Wholesale", value: "W"}, {text: "Triangulation", value: "T"}])
    const [type, setType] = useState({ text: "", value: "", isTriangulation: false, salePriceType: "" });
    
    const [warehouseDestinations, setWarehouseDestinations] = useState([]);
    const [warehouseDestination, setWarehouseDestination] = useState({ text: "", value: "" });

    const [reconditionTypes, setReconditionTypes] = useState([]);
    const [reconditionType, setReconditionType] = useState({ text: "", value: ""});

    const [isTriangulation, setIsTriangulation] = useState(false);
    const [salePriceType, setSalePriceType] = useState('FullPrice');
    const [deliveryNote, setDeliveryNote] = useState('');
    const [notes, setNotes] = useState('');
    const [isDamaged, setIsDamaged] = useState(false);
    const [canUploadExcel, setCanUploadExcel] = useState(false);

    const [openModalUploadExcel, setopenModalUploadExcel] = useState(false);
    const handleOpenModalUploadExcel = () => setopenModalUploadExcel(true);
    const handleCloseModalUploadExcel = () => setopenModalUploadExcel(false);

    const idCompany = useSelector((state) => state.common.company);
    const customerCode = useSelector((state) => state.actas.customerCode);
    const shopCode = useSelector((state) => state.actas.shopCode);
    const jdaLocationCode = useSelector((state) => state.actas.jdaLocationCode);
    
    var navigate = useNavigate();
    const { setLoading } = useLoading();

    useEffect(() => {
      if (
        customerCode === null ||
        customerCode === undefined ||
        customerCode === ""
      ) {
        toast.error(intl.formatMessage({ id: "RACreation.NoActAs" }));
        navigate(`${process.env.PUBLIC_URL}/ActAs`);
        return;
      }
    }, []);

    useEffect(() => {
      if (type.value != "") {
        getWarehouseDestinations();
      }
    }, [type, salePriceType, isDamaged, isTriangulation]);

    useEffect(() => {
      if (
        warehouseDestination?.value != "" &&
        warehouseDestination?.value != undefined &&
        warehouseDestination != null
      ) {
        getReconditionTypes();
      }
    }, [warehouseDestination]);

    useEffect(() => {
      handleChangeWarehouseDestination();
      //setReconditionType({ text: "", value: "", idRFType: ""});
      handleChangeReconditionType();
    }, [type, salePriceType, isDamaged]);

    useEffect(() => {
      let canUploadExcel =
        (type.value != "" && warehouseDestination.value != "")
        && (isTriangulation || reconditionType.value != "");

      setCanUploadExcel(canUploadExcel);
    }, [type, warehouseDestination, reconditionType]);

    const handleChangeDossierType = (item) => {
      setIsTriangulation(item.value == "T");
      setType(item);
    };

    const handleSalePriceTypeChange = (event) => {
    setSalePriceType(event.target.value);
    };

    const getReconditionTypes = async () => {
      setLoading(true);
      const params = new URLSearchParams([]);
      params.append("idJDALocationDestination", warehouseDestination.value);
      params.append("rfTypeGroup", type.text);
      axios
        .get("/creditnotereturnfiles/reconditiontypes", {params})
        .then((response) => {
          setLoading(false);
          var selectReconditionTypes = [];
          if (response.data !== undefined) {
            response.data.map((x) => {
              selectReconditionTypes.push({
                value: x.idReconditionType,
                text: x.description,
              });
            });
          }
          setReconditionTypes(selectReconditionTypes);

          if(selectReconditionTypes.length == 1){
            setReconditionType({ text: response.data[0].description, value: response.data[0].idReconditionType });
          }
        })
        .catch((error) => {
          setLoading(false);
          handleError(error, intl);
        });
    }

    const getWarehouseDestinations = async () => {
      setLoading(true);

      axios
        .get("/creditnotereturnfiles/warehousedestinations", {
          params: {
            salePriceType: salePriceType,
            isDamaged: isDamaged,
            isTriangulation: isTriangulation,
            customerCode: customerCode,
            jdaLocation: jdaLocationCode
          }
        })
        .then((response) => {
          setLoading(false);
          var selectWhdestinations = [];
          if (response.data !== undefined) {
            response.data.map((x) => {
              selectWhdestinations.push({
                value: x.idJDALocationDestination,
                text: x.jdaLocation + " - " + x.description,
              });
            });
          }
          setWarehouseDestinations(selectWhdestinations);
        })
        .catch((error) => {
          setLoading(false);
          handleError(error, intl);
        });
    };

    const handleActCreateDossier = () => {
      setLoading(true);
      const params = new URLSearchParams([]);
      params.append("idCompany", idCompany);
      params.append("senderCustomerCode", customerCode);
      if (shopCode != null) {
        params.append("senderShopCode", shopCode);
      }
      params.append(
        "idJDALocationDestination",
        warehouseDestination.value
      );
      if (salePriceType !== undefined && salePriceType !== "") {
        params.append("discriminant", salePriceType);
      }
      params.append("isTriangulation", isTriangulation);
      params.append("note", notes);
      params.append("deliveryNotes", deliveryNote);
      params.append("idReconditionType", reconditionType.value);
      params.append("isDamaged", isDamaged);
      params.append("dossierType", type.text);

      var url = "/creditnotereturnfiles/create";
      if (params.size > 0) {
        url += "?" + params.toString();
      }
      axios
        .post(url)
        .then((response) => {
          setLoading(false);
          toast.success(intl.formatMessage({ id: "ManualRTV.CreatedDossier" }));
          navigate(`${process.env.PUBLIC_URL}/RAPreparing/${response.data}`)
        })
        .catch((error) => {
          setLoading(false);
          handleError(error, intl);
        });
    };

    const handleUploadExcel = () => {
      alert("upload excel")
    }

    const handleCheckBoxChange = (event) => {
      setIsDamaged(event.target.checked);
    };

    const handleChangeReconditionType = (item) => {
      if(item != null){
        setReconditionType(item);
      }
      else {
        setReconditionType({ text: "", value: "" });
      }
    }

    const handleChangeWarehouseDestination = (item) => {
      if(item != null){
        setWarehouseDestination(item);
      }
      else {
        setWarehouseDestination({ text: "", value: "" });
      }

      setReconditionType({ text: "", value: "" });
      setReconditionTypes([]);
    }

    return (
      <div>
        <PageHeader title={intl.formatMessage({ id: "ManualRTV.Title" })} />
        <Grid container spacing={5}>
          <Grid item xs={12} lg={6} mt={3}>
            <CustomInput
              labelText={intl.formatMessage({ id: "RA.Type" })}
              type="autocomplete"
              value={type}
              selectItems={types}
              setValue={handleChangeDossierType}
              textCol={3}
              inputCol={9}
            />
            <Grid container mt={1} mb={1}>
              <Grid item xs={12} lg={6}>
                <FormControl>
                  <RadioGroup
                    row
                    disabled
                    defaultValue={salePriceType}
                    value={salePriceType}
                    onChange={handleSalePriceTypeChange}
                    sx={{
                      border: 2,
                      borderColor: "#85ABD5",
                      borderRadius: "15px",
                      paddingRight: "15px",
                    }}
                  >
                    <FormControlLabel
                      value="FullPrice"
                      control={<Radio />}
                      label={
                        <Typography>
                          {intl.formatMessage({ id: "General.FullPrice" })}
                        </Typography>
                      }
                      labelPlacement="start"
                    />
                    <FormControlLabel
                      value="MarkDown"
                      control={<Radio />}
                      label={
                        <Typography>
                          {intl.formatMessage({ id: "General.MarkDown" })}
                        </Typography>
                      }
                      labelPlacement="start"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              {!isTriangulation ? (
                <Grid item xs={12} lg={6}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isDamaged}
                          onChange={handleCheckBoxChange}
                        />
                      }
                      label={intl.formatMessage({ id: "General.Damaged" })}
                    />
                  </FormGroup>
                </Grid>
            ) : (
              ""
            )}
            </Grid>
            <CustomInput
              labelText={
                isTriangulation
                  ? intl.formatMessage({
                      id: "ManualRTV.TriangulatiomWarehouse",
                    })
                  : intl.formatMessage({ id: "ManualRTV.TrecateWarehouse" })
              }
              type="autocomplete"
              value={warehouseDestination}
              selectItems={warehouseDestinations}
              setValue={handleChangeWarehouseDestination}
              textCol={3}
              inputCol={9}
            />
            {!isTriangulation ? (
              <CustomInput
                labelText={intl.formatMessage({ id: "RA.ReconditionType" })}
                type="autocomplete"
                value={reconditionType}
                selectItems={reconditionTypes}
                //setValue={setReconditionType}
                setValue={handleChangeReconditionType}
                textCol={3}
                inputCol={9}
              />
            ) : (
              ""
            )}
          </Grid>
          <Grid item xs={12} lg={6} mt={3}>
            <CustomInput
              labelText={intl.formatMessage({ id: "ManualRTV.DeliveryNotes" })}
              type="textMultiline"
              value={deliveryNote}
              setValue={setDeliveryNote}
              textCol={2}
              inputCol={10}
            />
            <CustomInput
              labelText={intl.formatMessage({ id: "RADetails.Notes" })}
              type="textMultiline"
              value={notes}
              setValue={setNotes}
              textCol={2}
              inputCol={10}
            />
          </Grid>
          <Grid item xs={5} lg={2}>
            <Button
              disabled={!canUploadExcel}
              variant="contained"
              className="apeLigthBlueBackground"
              sx={{ mt: 1, mr: 1 }}
              onClick={(e) => {
                handleOpenModalUploadExcel(e, 1);
              }}
            >
              {intl.formatMessage({ id: "RAPreparing.UploadExcel" })}
            </Button>
          </Grid>
          <Grid item xs={2} lg={8}></Grid>
          <Grid item xs={5} lg={2} textAlign={"end"}>
            <Button
              variant="contained"
              className="apeLigthBlueBackground"
              sx={{ mt: 1, mr: 1 }}
              onClick={handleActCreateDossier}
            >
              {intl.formatMessage({ id: "ManualRTV.CreateDossier" })}
            </Button>
          </Grid>
        </Grid>

        <UploadExcelModal
          openModal={openModalUploadExcel}
          handleCloseModal={handleCloseModalUploadExcel}
          idReturnFileHead={1}
          salePriceType={salePriceType}
          isDamaged={isDamaged}
          warehouseDestination={warehouseDestination}
          reconditionType={reconditionType}
          dossierType={type}
          idCompany={idCompany}
          shopCode={shopCode}
          customerCode={customerCode}
          isTriangulation={isTriangulation}
          deliveryNote={deliveryNote}
          notes={notes}
          idRFType={reconditionType.idRFType}
        />
      </div>
    );
};

export default ManualRTV;